import { getAsync as _getAsync } from "../api";

let BASE_URL = null;

export function initDB(dbName) {
    BASE_URL = `/modules/${dbName}/file-cases/reports`;
}

export async function getLabelsByTypeAsync(typeId) {
    return _getAsync({ url: `${BASE_URL}/labels/${typeId}` });
}
